import React, { useContext, useEffect, useState, createRef } from 'react';
import { AppContext } from "../../context/app/appContext";
import { useHistory } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import axios from "axios";

const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';

export const LoginPage = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [temporaryPassword, setTemporaryPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');

    const appContext = useContext(AppContext);
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [isVisibleForgotPasswordForm, setIsVisibleShowForgotPasswordForm] = useState(false);
    const [showResetPasswordForm, setShowResetPasswordForm] = useState(false);
    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [feedbackMessageClass, setFeedbackMessageClass] = useState('error');

    const googleLoginBtn = createRef()

    const showFeedbackMessage = (message, error = true) => {
        setFeedbackMessage(message);
        if (error) setFeedbackMessageClass('error');
        if (!error) setFeedbackMessageClass('success');
    }

    const handleLogin = async (event) => {
        setLoading(true);
        event.preventDefault();
        console.info(`login...`);

        const dashboardLoginRequest = await axios.post(`${baseURL}/dashboard-login`, { email, password }).catch(error => {
            console.info({ error });
            setLoading(false);
            if (error.isAxiosError && error.response.data && error.response.data.status) {
                const { code, message } = error.response.data.status;
                console.info({ code, message });
                return showFeedbackMessage(message);
            }
            return showFeedbackMessage(`Sorry, there was an error. Please try again later.`);
        });

        if (dashboardLoginRequest && dashboardLoginRequest.data && dashboardLoginRequest.data.data) {
            const { code, message } = dashboardLoginRequest.data.status;
            console.info({ code, message });
            if (code === `user/pending-reset-password`) {
                setLoading(false);
                setTemporaryPassword(password);
                showFeedbackMessage(message, false);
                setIsVisibleShowForgotPasswordForm(false);
                setShowResetPasswordForm(true);
            }

            const user = dashboardLoginRequest.data.data;
            console.log('check user info here')
            console.info({ user });
            if (user && user.accessToken) {
                localStorage.setItem('accessToken', user.accessToken);
                localStorage.setItem('email', user.email);
                await appContext.setAuthorizedUser(user);
                await appContext.setOrganization(user.accessToken); // TODO: should be in Organization page load, so that each time it can be reloaded
                setLoading(false);
                // once logged-in fetch-organization API will pick organizationId from token
            }
            if (user.role === "SuperAdmin") { console.log("Super admin logged in"); setLoading(false); history.push('/super'); } else await appContext.setOrganization(user.accessToken)
        }
        // TODO: should be in Organization page load, so that each time it can be reloaded
        // await hideLoader(); // don't need to, we are redirecting
        // once logged-in fetch-organization API will pick organizationId from token
    }

    const handleForgotPasswordRequest = async (event) => {
        setLoading(true);
        event.preventDefault();
        console.info(`sending forgot password request...`);

        const forgotPasswordRequest = await axios.post(`${baseURL}/forgot-password`, { email }).catch(async error => {
            console.info({ error });
            setLoading(false);
            if (error.isAxiosError && error.response.data && error.response.data.status) {
                const { code, message } = error.response.data.status;
                console.info({ code, message });
                return showFeedbackMessage(message);
            }
            return showFeedbackMessage(`Sorry, there was an error. Please try again later.`);
        });

        if (forgotPasswordRequest && forgotPasswordRequest.data && forgotPasswordRequest.data.status) {
            const { code, message } = forgotPasswordRequest.data.status;
            console.info({ code, message });
            if (code === `account/forgot-password-requested`) {
                showFeedbackMessage(message, false);
                setIsVisibleShowForgotPasswordForm(false);
                setShowResetPasswordForm(false);
            }
            setLoading(false);
        }
    }

    const handleResetPassword = async (event) => {
        event.preventDefault();

        if (newPassword !== confirmNewPassword) return showFeedbackMessage(`Passwords do not match. Please make sure passwords in both fields are the same.`);

        setLoading(true);

        console.info(`sending reset password request...`);

        const forgotPasswordRequest = await axios.post(`${baseURL}/reset-password`, { email, oldPassword: temporaryPassword, newPassword, }).catch(async error => {
            console.info({ error });
            setLoading(false);
            if (error.isAxiosError && error.response.data && error.response.data.status) {
                const { code, message } = error.response.data.status;
                console.info({ code, message });
                return showFeedbackMessage(message);
            }
            return showFeedbackMessage(`Sorry, there was an error. Please try again later.`);
        });

        if (forgotPasswordRequest && forgotPasswordRequest.data && forgotPasswordRequest.data.status) {
            const { code, message } = forgotPasswordRequest.data.status;
            console.info({ code, message });
            if (code === `account/password-reset-successful`) {
                showFeedbackMessage(message, false);
                setShowResetPasswordForm(false);
                setIsVisibleShowForgotPasswordForm(false);
            }
            setLoading(false);
        }
    }

    /*const hideLoader = () => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(setLoading(false));
            }, 1000);
        })
    }*/

    useEffect(() => {
        if (appContext.user.accessToken && appContext.organization.legalEntityName) {
            if (appContext.organization.verified) history.push(`/`);
            else history.push(`/account`);

        }
        // eslint-disable-next-line
    }, [appContext.organization, appContext.user])

    const loader = (
        <Dimmer active>
            <Loader size="large">loading...</Loader>
        </Dimmer>
    )

    const feedbackBlock = (
        <div className={`ui message ${feedbackMessageClass}`}>
            <div className="content">{feedbackMessage}</div>
        </div>
    );

    const showForgotPasswordForm = () => {
        showFeedbackMessage('');
        setIsVisibleShowForgotPasswordForm(true);
    }

    const showLoginForm = () => {
        showFeedbackMessage('');
        setPassword('');
        setIsVisibleShowForgotPasswordForm(false);
        setShowResetPasswordForm(false);
    }

    const loginFormActionButtons = <>
        <button className="ui button primary">Login</button>
        <p className="forgot-password-link" onClick={showForgotPasswordForm}>Forgot password?</p>
    </>;
    const loginForm = <form className="ui large form center aligned text-center" onSubmit={handleLogin}>
        <div className="field">
            <div className="ui fluid input"><input type="email" placeholder="Your work email" onChange={e => setEmail(e.target.value)} value={email} required /></div>
        </div>

        <div className="field">
            <div className="ui fluid input"><input type="password" placeholder="Password" onChange={e => setPassword(e.target.value)} value={password} required /></div>
        </div>

        {loading ? loader : ''}
        {!loading ? loginFormActionButtons : ''}
        {/* <button className="ui button" onClick={() => {history.push('/login-redirect-google')}}>Google</button> */}
    </form>;

    const forgotPasswordForm = <>
        <form className="ui large form center aligned text-center" onSubmit={handleForgotPasswordRequest}>
            <div className="field">
                <div className="ui fluid input"><input type="email" placeholder="Your work email" onChange={e => setEmail(e.target.value)} value={email} required /></div>
            </div>

            {loading ? loader : ''}
            {!loading ? (<button className="ui button primary">Send</button>) : ''}
            <p className="forgot-password-link" onClick={showLoginForm}>Login</p>
        </form>
    </>;

    const resetPasswordForm = <>
        <form className="ui large form center aligned text-center" onSubmit={handleResetPassword}>
            <div className="field">
                <div className="ui fluid input"><input type="password" placeholder="New Password" onChange={e => setNewPassword(e.target.value)} value={newPassword} required /></div>
            </div>

            <div className="field">
                <div className="ui fluid input"><input type="password" placeholder="Confirm New Password" onChange={e => setConfirmNewPassword(e.target.value)} value={confirmNewPassword} required />
                </div>
            </div>

            {loading ? loader : ''}
            {!loading ? (<button className="ui button primary">Reset Password</button>) : ''}
        </form>
    </>;

    return (
        <div id="login-page" className="ui centered two column grid middle aligned">
            <div className="ui segment column login-panel">

                <header>
                    <h1 className="login-logo">Perkfix</h1>
                    <h2>People Ops</h2>
                </header>

                {feedbackMessage ? feedbackBlock : ''}

                {(!isVisibleForgotPasswordForm && !showResetPasswordForm) && loginForm}

                <div className="vl">
                    <span className="vl-innertext">or</span>
                </div>
                <div style={{ marginTop: "60px" }}>
                    {(!isVisibleForgotPasswordForm && !showResetPasswordForm) && <a className="btnn btnn--google" onClick={() => { history.push('/login-redirect-google') }}>Sign in with Google</a>}
                    {(!isVisibleForgotPasswordForm && !showResetPasswordForm) && <a className="btnn btnn--okta" onClick={() => { history.push('/login-redirect-okta') }}>Sign in with Okta</a>}

                    {(!isVisibleForgotPasswordForm && !showResetPasswordForm) && <a className="btnn btnn--microsoft" onClick={() => { history.push('/login-redirect-microsoft') }}>Sign in with Microsoft</a>}

                </div>
                {/* 
                 {(!isVisibleForgotPasswordForm && !showResetPasswordForm) && <button className="ui button" onClick={() => { history.push('/login-redirect-google') }}>Google</button>}
                {(!isVisibleForgotPasswordForm && !showResetPasswordForm) && <button className="ui button" onClick={() => { history.push('/login-redirect-okta') }}>Okta</button>}

                {(!isVisibleForgotPasswordForm && !showResetPasswordForm) && <button className="ui button" onClick={() => {history.push('/login-redirect-microsoft')}}>Microsoft</button>}  */}

                {isVisibleForgotPasswordForm && forgotPasswordForm}

                {showResetPasswordForm && resetPasswordForm}
            </div>
        </div>
    );
};
